import { useEffect, useRef, useState } from 'react';
import {
  IAPIServiceConfigItem,
  IAuditItem,
  IClientAPIDrafts,
  IClientAPIList,
  IClientAPIResult,
  IServiceStatus,
} from '../../../../model/api-modules';
import {
  GameEnvRegion,
  IGameEnvModel,
} from '../../../../model/api-modules/env';
import getFormatMessage from '../../../../locales/get-format-message';
import { Form, Input, Select, Spin, Switch } from 'antd';
import EnvDevIcon from '../../../../assets/img/env-dev-icon.png';
import EnvLiveIcon from '../../../../assets/img/env-live-icon.png';
import HistoryIcon from '../../../../assets/svg/history.svg';
import {
  getAllServiceStatus,
  getClientAPI,
  queryHistoryTask,
  modifyClientApiDraft,
  discardClientApiDraft,
  publishClientApiDraft,
} from '../../../../api/services';
import classNames from 'classnames';
import { CustomPopover } from '../../../../components/custom-popover';
import arrowRightUp from '../../../../assets/svg/arrow-right-up.svg';
import warningCircleFill from '../../../../assets/svg/warning-circle-fill.svg';
import warnBlue from '../../../../assets/svg/warn-blue.svg';
import addIcon from '../../../../assets/svg/group-add-icon.svg';
import questionIcon from '../../../../assets/svg/question-icon.svg';
import emptyPng from '../../../../assets/img/empty.png';
import { PermissionCheck } from '../../../component/permission-check';
import { RbacRoleObjectKey } from '../../../../model';
import { AutoTable } from '../../../../components/auto-table';
import {
  getLocaleLanguage,
  getUserConfigZoneTimeByUTC8,
  LanguageType,
} from '../../../../lib';
import { ModalWrap } from '../../../component/modal-wrap';
import { messageError, messageSuccess } from '../../../../components/message';
import { useHistory } from 'react-router-dom';
import { auditReadLog, auditWriteLog } from '../../../lib/aduit-log';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';

interface IProps {
  readonly envList: ReadonlyArray<IGameEnvModel>;
  readonly gameID?: string;
  readonly allServiceConfig: ReadonlyArray<IAPIServiceConfigItem> | null;
  readonly envID: string;
  readonly onShowCreateDrawer: () => void;
  readonly studioId: string | null;
}
export const TabApi = (props: IProps) => {
  const [selectEnv, setSelectEnv] = useState<number | null>(
    Number(props.envID)
  );
  const [selectService, setSelectService] = useState<string>('');
  const [historyTask, setHistoryTask] = useState<any>(null);
  const [clientApi, setClientApi] = useState<IClientAPIResult | null>(null);
  const [allServiceStatus, setAllServiceStatus] = useState<Record<
    string,
    IServiceStatus[] | null
  > | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showDiscardConfirm, setShowDiscardConfirm] = useState<boolean>(false);
  const [showPublish, setShowPublish] = useState<boolean>(false);
  // const [showPublishConfirm, setShowPublishConfirm] = useState<boolean>(false);
  const [publishStep, setPublishStep] = useState<number>(1);
  const [isNeedPoll, setIsNeedPoll] = useState<boolean>(false);
  const [versionForm] = Form.useForm();
  const history = useHistory();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const envItem = props.envList.find((item) => item.id === selectEnv);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const compareVersions = (versionA: string, versionB: string) => {
    const currentVersionA = versionA || 'v0.0.0';
    // 移除开头的'v'并分割为数字数组
    const partsA = currentVersionA
      .replace(/^v/, '')
      .replace(/-.*$/, '')
      .split('.')
      .map(Number);
    const partsB = versionB
      .replace(/^v/, '')
      .replace(/-.*$/, '')
      .split('.')
      .map(Number);

    // 比较每个部分
    for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
      const a = partsA[i] || 0;
      const b = partsB[i] || 0;

      if (a > b) return 1;
      if (a < b) return -1;
    }

    return 0;
  };

  const isVersionGreaterThan = (version: string, targetVersion: string) => {
    return compareVersions(version, targetVersion) >= 0;
  };
  const gos = JSON.parse(envItem?.GosParams || '{}');
  const isAbled = isVersionGreaterThan(gos?.GameServiceVersion, 'v1.10.0');

  const getClientAPIList = async () => {
    if (props.gameID && envItem) {
      setLoading(true);
      const res = await getClientAPI(props.gameID, envItem.id, envItem.Guid);
      setLoading(false);
      if (res) {
        setClientApi(res.result);
      }
    }
  };

  const queryHistoryTaskList = async () => {
    if (props.gameID && envItem) {
      const res = await queryHistoryTask(
        props.gameID,
        envItem.id,
        envItem.Guid,
        531
      );
      if (res) {
        setHistoryTask(res.result);
        if (res.result?.[0]?.status === 0 || res.result?.[0]?.status === 1) {
          setIsNeedPoll(true);
        } else if (res.result?.[0]?.status > 1 && isNeedPoll) {
          // 如果发布任务结束并且正在轮询
          setIsNeedPoll(false);
        }
      }
    }
  };

  const getAllServiceStatusList = async () => {
    if (props.gameID && envItem) {
      const res = await getAllServiceStatus(props.gameID, envItem.id);
      if (res) {
        setAllServiceStatus(res);
        const playerConfig = props.allServiceConfig?.find(
          (item) => item.Name === 'Player'
        );
        if (playerConfig) {
          const statusItem = res[playerConfig.id];
          if (statusItem) {
            const openedItem = statusItem?.find(
              (item) => item.stage === 'opened'
            );
            if (openedItem) {
              setSelectService('Player');
            }
          }
        }
      }
    }
  };

  const getRegionName = (value: string): string | undefined => {
    return Object.entries(GameEnvRegion).find(([, v]) => v === value)?.[0];
  };

  const init = () => {
    getClientAPIList();
    queryHistoryTaskList();
    getAllServiceStatusList();
  };

  useEffect(() => {
    const pathname = location.pathname.split('/');
    const gameInfoIndex = pathname.indexOf('game-info');
    if (gameInfoIndex !== -1) {
      const gameId = pathname[gameInfoIndex + 1];
      auditReadLog(IAuditItem.ViewClientAPIControl, {
        gameID: gameId,
        envID: envItem?.Guid || '',
        envType: envItem?.Type,
        detail: {
          gameID: gameId,
          envID: envItem?.Guid || '',
        },
      });
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (isNeedPoll) {
      // 设置3秒的轮询间隔
      timerRef.current = setInterval(() => {
        queryHistoryTaskList();
      }, 3000);
    } else {
      init();
      // 清除定时器
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isNeedPoll]);

  useEffect(() => {
    init();
  }, [selectEnv, props.gameID, props.envID]);

  const handleEnvChange = (value: number) => {
    const selectedEnvItem = props.envList.find((item) => item.id === value);
    auditReadLog(IAuditItem.ViewClientAPIControl, {
      gameID: props.gameID,
      envID: selectedEnvItem?.Guid || '',
      envType: selectedEnvItem?.Type,
      detail: {
        gameID: props.gameID,
        envID: selectedEnvItem?.Guid || '',
      },
    });
    setSelectEnv(value);
  };

  const clickServicesMenu = (name: string) => {
    setSelectService(name);
  };

  const goToApply = (serviceId: number | undefined) => {
    window.open(
      `${location.origin}/console/build/${props.gameID}/${envItem?.id}/${serviceId}`,
      '_blank'
    );
  };

  // 小写去空格
  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const getCreateName = (name: string) => {
    if (!name) return '';
    const nameArr = name.split('@');
    return nameArr[0] || '';
  };

  const renderLeftMenu = () => {
    const clientApiServices: Record<string, number> = {};
    clientApi?.api_list &&
      clientApi.api_list.length !== 0 &&
      clientApi.api_list.forEach((item) => {
        if (!clientApiServices[item.service_name]) {
          clientApiServices[item.service_name] = 1;
        } else {
          clientApiServices[item.service_name] =
            clientApiServices[item.service_name] + 1;
        }
      });
    const serviceKeys = Object.keys(clientApiServices) || [];
    serviceKeys.sort((a, b) => {
      const aConfig = props.allServiceConfig?.find((it) => {
        if (it.Name === a) {
          return it;
        }
        if (
          it.SubServiceNames &&
          it.SubServiceNames.indexOf(toLowerCaseAndRemoveSpaces(a)) !== -1
        ) {
          return it;
        }
        if (a === 'Private Chat' || a === 'Group Chat' || a === 'Global Chat') {
          return it.Name === 'Text Chat';
        }
        if (a === 'Token') {
          return it.Name === 'Battle';
        }
        return false;
      });
      const bConfig = props.allServiceConfig?.find((it) => {
        if (it.Name === b) {
          return it;
        }
        if (
          it.SubServiceNames &&
          it.SubServiceNames.indexOf(toLowerCaseAndRemoveSpaces(b)) !== -1
        ) {
          return it;
        }
        if (b === 'Private Chat' || b === 'Group Chat' || b === 'Global Chat') {
          return it.Name === 'Text Chat';
        }
        if (b === 'Token') {
          return it.Name === 'Battle';
        }
        return false;
      });
      if (!aConfig || !bConfig) {
        return -1;
      }
      if (aConfig.ParentSort !== bConfig.ParentSort) {
        return aConfig.ParentSort - bConfig.ParentSort;
      }
      return Number(aConfig.Sort) - Number(bConfig.Sort);
    });
    return (
      <div className="client-api-body-left">
        <div className="client-api-body-left-header">
          {getFormatMessage('service_name')}
        </div>
        {serviceKeys.map((item) => {
          const configItem = props.allServiceConfig?.find((it) => {
            if (
              item === 'Private Chat' ||
              item === 'Group Chat' ||
              item === 'Global Chat'
            ) {
              return it.Name === 'Text Chat';
            }
            // Token依赖Party Lobby
            if (item === 'Token') {
              return it.Name === 'Battle';
            }
            // 主服务匹配或者子服务匹配
            return (
              it.Name === item ||
              (it.SubServiceNames &&
                it.SubServiceNames.indexOf(toLowerCaseAndRemoveSpaces(item)) !==
                  -1)
            );
          });
          const statusItem =
            allServiceStatus && configItem
              ? allServiceStatus[configItem.id]
              : [];
          const openedItem = statusItem?.find((it) => {
            // 主服务匹配
            if (configItem?.Name === item) {
              return it.stage === 'opened';
            }
            // 子服务匹配
            if (
              configItem?.SubServiceNames &&
              configItem?.SubServiceNames?.indexOf(
                toLowerCaseAndRemoveSpaces(item)
              ) !== -1
            ) {
              return (
                it.stage === 'opened' &&
                it.subserviceName &&
                it.subserviceName?.indexOf(toLowerCaseAndRemoveSpaces(item)) !==
                  -1
              );
            }
            // 特殊匹配
            if (
              (item === 'Private Chat' ||
                item === 'Group Chat' ||
                item === 'Global Chat') &&
              configItem?.Name === 'Text Chat'
            ) {
              return it.stage === 'opened';
            }
            if (item === 'Token' && configItem?.Name === 'Battle') {
              return (
                it.stage === 'opened' &&
                (it.subserviceName === 'party' || it.subserviceName === 'lobby')
              );
            }
            return false;
          });
          let isModify = false;
          const filterList =
            clientApi?.api_list && clientApi?.api_list.length !== 0
              ? clientApi?.api_list.filter((it) => it.service_name === item)
              : [];
          filterList.forEach((it) => {
            const drafts = clientApi?.drafts || [];
            const draftItem = drafts.find(
              (draftIt) =>
                draftIt.client_api_key === it.api_name &&
                draftIt.package_name_service_name ===
                  it.package_name_service_name
            );
            if (draftItem && draftItem.is_published === 0) {
              isModify = true;
            }
          });
          if (openedItem) {
            return (
              <div
                onClick={() => clickServicesMenu(item)}
                className={classNames(
                  'client-api-body-left-item',
                  selectService === item ? 'left-item-active' : ''
                )}
              >
                <div className="left-item-name">
                  <span className="left-item-name-left">{item}</span>
                  {isModify && (
                    <div className="client-api-tag">
                      {getFormatMessage('email_modify')}
                    </div>
                  )}
                </div>
                <div className="left-item-num">{clientApiServices[item]}</div>
              </div>
            );
          }
          return (
            <CustomPopover
              content={
                <div className="client-api-body-left-popover">
                  <div className="client-api-body-left-popover-top">
                    {getFormatMessage('no_configurations_tips', {
                      params: { serviceName: item },
                    })}
                  </div>
                  <div className="client-api-body-left-popover-bottom">
                    <span
                      className="client-api-body-left-popover-bottom-box"
                      onClick={() => goToApply(configItem?.id)}
                    >
                      <span>{getFormatMessage('go_to_apply')}</span>
                      <img src={arrowRightUp} />
                    </span>
                  </div>
                </div>
              }
            >
              <div
                className={classNames(
                  'client-api-body-left-item',
                  'left-item-no-opened'
                )}
              >
                <span className="left-item-name">{item}</span>
                <span className="left-item-num">{clientApiServices[item]}</span>
              </div>
            </CustomPopover>
          );
        })}
      </div>
    );
  };

  const changeApiDraft = (checked: boolean, record: IClientAPIList) => {
    modifyApiDraft(checked, record);
  };

  const modifyApiDraft = async (checked: boolean, record: IClientAPIList) => {
    if (props.gameID && envItem) {
      setLoading(true);
      const res = await modifyClientApiDraft(
        props.gameID,
        envItem.id,
        envItem.Guid,
        record.service_name,
        record.api_name,
        checked,
        record.module_name,
        record.package_name_service_name
      );
      auditWriteLog(
        checked ? IAuditItem.EnableClientAPI : IAuditItem.DisableClientAPI,
        {
          gameID: props.gameID,
          envID: envItem.Guid,
          envType: envItem.Type,
          detail: {
            gameID: props.gameID,
            envID: envItem.Guid,
            service: record.service_name,
            client_api_key: record.api_name,
            is_enabled: checked,
            module_name: record.module_name,
            package_name_service_name: record.package_name_service_name,
          },
        }
      );
      if (res === 0) {
        getClientAPIList();
      } else if (res === 10028) {
        messageError(getFormatMessage('task_being_published'));
      } else if (res === 10029) {
        messageError(getFormatMessage('service_not_deployed'));
      } else {
        messageError(getFormatMessage('operation_failed'));
      }
      setLoading(false);
    }
  };

  const clickDiscardClientApiDraft = async () => {
    if (props.gameID && envItem) {
      setLoading(true);
      const res = await discardClientApiDraft(
        props.gameID,
        envItem.id,
        envItem.Guid
      );
      auditWriteLog(IAuditItem.DiscardAllClientAPI, {
        gameID: props.gameID,
        envID: envItem.Guid,
        envType: envItem.Type,
        detail: {
          gameID: props.gameID,
          envID: envItem.Guid,
        },
      });
      setLoading(false);
      setShowDiscardConfirm(false);
      if (res === 0) {
        messageSuccess(getFormatMessage('operate_success'));
        getClientAPIList();
        return true;
      }
      if (res === 10028) {
        messageError(getFormatMessage('task_being_published'));
        return false;
      }
      messageError(getFormatMessage('operate_fail'));
      return false;
    }
    return false;
  };

  const renderDiscardConfirm = () => {
    if (showDiscardConfirm) {
      return (
        <ModalWrap
          title={
            <div>
              <img
                src={warningCircleFill}
                style={{
                  display: 'inline-block',
                  width: 16,
                  height: 16,
                  margin: '-3px 8px 0 0',
                }}
              />
              <span>{getFormatMessage('discard_changes')}</span>
            </div>
          }
          onClose={() => setShowDiscardConfirm(false)}
          cancelText={getFormatMessage('cancel')}
          okButtonProps={{ danger: true }}
          oKText={getFormatMessage('confirm')}
          onOk={clickDiscardClientApiDraft}
        >
          <div>{getFormatMessage('discard_changes_tips')}</div>
        </ModalWrap>
      );
    }
    return null;
  };

  const cancelPublish = () => {
    setShowPublish(false);
    setPublishStep(1);
    versionForm.resetFields();
  };

  const goToHistory = () => {
    if (props.studioId) {
      history.push(
        `/studio/${props.studioId}/audithub?task=publish&subtask=server_controller.access`
      );
    }
  };

  const submitPublish = async () => {
    if (publishStep === 1) {
      setPublishStep(2);
    } else {
      try {
        const values = await versionForm.validateFields();
        if (values) {
          ModalWrap.show({
            title: (
              <div>
                <img
                  src={warningCircleFill}
                  style={{
                    display: 'inline-block',
                    width: 16,
                    height: 16,
                    margin: '-3px 8px 0 0',
                  }}
                />
                <span>{getFormatMessage('publish_confirm')}</span>
              </div>
            ),
            cancelText: getFormatMessage('cancel'),
            okButtonProps: { danger: true },
            oKText: getFormatMessage('confirm'),
            onOk: confirmSubmitPublish,
            children: getFormatMessage('confirm_changes_api_tips'),
          });
        }
      } catch (error) {
        console.error('表单验证失败:', error);
      }
    }
  };

  const confirmSubmitPublish = async () => {
    const values = await versionForm.validateFields();
    if (values && props.gameID && envItem) {
      const version = values.versionName.trim();
      const desc = values.versionDesc || '';
      const res = await publishClientApiDraft(
        props.gameID,
        envItem.id,
        envItem.Guid,
        version,
        desc
      );
      auditWriteLog(IAuditItem.PublishClientAPI, {
        gameID: props.gameID,
        envID: envItem.Guid,
        envType: envItem.Type,
        detail: {
          gameID: props.gameID,
          envID: envItem.Guid,
          version,
          description: desc,
        },
      });
      if (res === 0) {
        messageSuccess(getFormatMessage('publish_task_submit_success'));
        cancelPublish();
        init();
        return true;
      }
      if (res === 10014) {
        messageError(getFormatMessage('task_is_incomplete'));
        return true;
      }
    }
    messageError(getFormatMessage('notice_publish_fail'));
    return true;
  };

  // const renderPublishConfirm = () => {
  //     if (showPublishConfirm) {
  //         return (
  //             <ModalWrap
  //                 title={
  //                     <div>
  //                         <img
  //                             src={warningCircleFill}
  //                             style={{
  //                                 display: 'inline-block',
  //                                 width: 16,
  //                                 height: 16,
  //                                 margin: '-3px 8px 0 0',
  //                             }}
  //                         />
  //                         <span>{getFormatMessage('publish_confirm')}</span>
  //                     </div>
  //                 }
  //                 onClose={() => setShowPublishConfirm(false)}
  //                 cancelText={getFormatMessage('cancel')}
  //                 okButtonProps={{ danger: true }}
  //                 oKText={getFormatMessage('confirm')}
  //                 onOk={confirmSubmitPublish}
  //             >
  //                 <div>{getFormatMessage('confirm_changes_api_tips')}</div>
  //             </ModalWrap>
  //         );
  //     }
  //     return null;
  // };

  const columns = [
    {
      key: 'api_name',
      name: getFormatMessage('tag'),
      tableExtension: {
        renderRow(key: string, value: string, row: IClientAPIList) {
          const record = row as IClientAPIList;
          const drafts = clientApi?.drafts || [];
          const draftItem = drafts.find(
            (item) =>
              item.client_api_key === value &&
              item.package_name_service_name ===
                record.package_name_service_name
          );
          if (draftItem && draftItem.is_published === 0) {
            return (
              <div className="client-api-tag">
                {getFormatMessage('email_modify')}
              </div>
            );
          }
          return '';
        },
      },
    },
    {
      key: 'api_name',
      name: getFormatMessage('client_api'),
    },
    {
      key: 'api_name',
      name: getFormatMessage('interface_description'),
      tableExtension: {
        renderRow(key: string, value: string, row: IClientAPIList) {
          const record = row as IClientAPIList;
          const currentStoreLanguage =
            getLocaleLanguage() || LanguageType.en_US;
          if (currentStoreLanguage === LanguageType.zh_CN) {
            return record.description_cn;
          }
          return record.description_en;
        },
      },
    },
    {
      key: 'api_name',
      name: getFormatMessage('permission_status'),
      tableExtension: {
        renderRow(key: string, value: string, row: IClientAPIList) {
          const record = row as IClientAPIList;
          const drafts = clientApi?.drafts || [];
          const draftItem = drafts.find(
            (item) =>
              item.client_api_key === value &&
              item.package_name_service_name ===
                record.package_name_service_name
          );
          // 0关闭 1开启 默认开启
          let isChecked = 1;
          if (draftItem) {
            isChecked =
              draftItem.is_published === 0
                ? draftItem.draft_is_enabled
                : draftItem.published_is_enabled;
          }
          return (
            <PermissionCheck
              permissionKey={RbacRoleObjectKey.ClientAPIControlEdit}
              otherTips={
                !record.is_developer_access_controlled
                  ? getFormatMessage('api_cannot_be_disabled')
                  : ''
              }
            >
              <Switch
                onChange={(checked) => changeApiDraft(checked, record)}
                checked={isChecked === 1}
                disabled={!record.is_developer_access_controlled}
                loading={loading}
              />
            </PermissionCheck>
          );
        },
      },
    },
    {
      key: 'api_name',
      name: getFormatMessage('last_modified_by'),
      tableExtension: {
        renderRow(key: string, value: string, row: IClientAPIList) {
          const record = row as IClientAPIList;
          const drafts = clientApi?.drafts || [];
          const draftItem = drafts.find(
            (item) =>
              item.client_api_key === value &&
              item.package_name_service_name ===
                record.package_name_service_name
          );
          if (draftItem) {
            return draftItem.is_published === 0
              ? getCreateName(draftItem.draft_operator || '')
              : getCreateName(draftItem.published_operator || '');
          }
          return '--';
        },
      },
    },
    {
      key: 'api_name',
      name: getFormatMessage('last_modified_time'),
      tableExtension: {
        renderRow(key: string, value: string, row: IClientAPIList) {
          const record = row as IClientAPIList;
          const drafts = clientApi?.drafts || [];
          const draftItem = drafts.find(
            (item) =>
              item.client_api_key === value &&
              item.package_name_service_name ===
                record.package_name_service_name
          );
          if (draftItem) {
            return draftItem.is_published === 0
              ? getUserConfigZoneTimeByUTC8(
                  draftItem.draft_modify_time || '',
                  userInfo?.UserSettings?.Timezone
                )
              : getUserConfigZoneTimeByUTC8(
                  draftItem.published_modify_time || '',
                  userInfo?.UserSettings?.Timezone
                );
          }
          return '--';
        },
      },
    },
  ];

  const publishColumns = [
    {
      key: 'is_published',
      name: getFormatMessage('tag'),
      tableExtension: {
        renderRow(key: string, value: number) {
          if (value === 0) {
            return (
              <div className="client-api-tag">
                {getFormatMessage('email_modify')}
              </div>
            );
          }
          return '';
        },
      },
    },
    {
      key: 'client_api_key',
      name: getFormatMessage('client_api'),
    },
    {
      key: 'client_api_key',
      name: getFormatMessage('interface_description'),
      tableExtension: {
        renderRow(key: string, value: string) {
          const apiList = clientApi?.api_list || [];
          const apiItem = apiList.find((item) => item.api_name === value);
          const currentStoreLanguage =
            getLocaleLanguage() || LanguageType.en_US;
          if (apiItem) {
            if (currentStoreLanguage === LanguageType.zh_CN) {
              return apiItem.description_cn;
            }
            return apiItem.description_en;
          }
          return '';
        },
      },
    },
    {
      key: 'is_published',
      name: getFormatMessage('permission_status'),
      tableExtension: {
        renderRow(key: string, value: number, row: IClientAPIDrafts) {
          const record = row as IClientAPIDrafts;
          // 0关闭 1开启 默认开启
          const isChecked =
            value === 0 ? record.draft_is_enabled : record.published_is_enabled;
          return <Switch disabled checked={isChecked === 1} />;
        },
      },
    },
    {
      key: 'is_published',
      name: getFormatMessage('last_modified_by'),
      tableExtension: {
        renderRow(key: string, value: number, row: IClientAPIDrafts) {
          const record = row as IClientAPIDrafts;
          return value === 0
            ? getCreateName(record.draft_operator || '')
            : getCreateName(record.published_operator || '');
        },
      },
    },
    {
      key: 'is_published',
      name: getFormatMessage('last_modified_time'),
      tableExtension: {
        renderRow(key: string, value: number, row: IClientAPIDrafts) {
          const record = row as IClientAPIDrafts;
          return value === 0
            ? getUserConfigZoneTimeByUTC8(
                record.draft_modify_time || '',
                userInfo?.UserSettings?.Timezone
              )
            : getUserConfigZoneTimeByUTC8(
                record.published_modify_time || '',
                userInfo?.UserSettings?.Timezone
              );
        },
      },
    },
  ];

  const handleNameBlur = (
    _rule: any,
    value: string,
    callback: (error?: string) => void
  ) => {
    const regex = /^[a-zA-Z][a-zA-Z0-9_]{0,127}$/;
    if (!regex.test(value)) {
      // 不符合要求，进行提示
      callback(getFormatMessage('version_name_validator'));
    } else {
      callback(); // 校验通过
    }
  };
  const handleDescBlur = (
    _rule: any,
    value: string,
    callback: (error?: string) => void
  ) => {
    const regex = /^.{0,1024}$/;
    if (!regex.test(value)) {
      // 不符合要求，进行提示
      callback(getFormatMessage('version_desc_validator'));
    } else {
      callback(); // 校验通过
    }
  };
  const filterList =
    clientApi?.api_list && clientApi?.api_list.length !== 0
      ? clientApi?.api_list.filter(
          (item) => item.service_name === selectService
        )
      : [];
  const noPublishList = clientApi?.drafts
    ? clientApi?.drafts.filter((item) => item.is_published === 0)
    : [];
  const formatTimeToVersion = () => {
    // 1. 获取当前时间（精确到毫秒）
    const now = new Date();

    // 2. 提取各时间组件并补零
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份补零
    const day = String(now.getDate()).padStart(2, '0'); // 日期补零
    const hours = String(now.getHours()).padStart(2, '0'); // 小时补零
    const minutes = String(now.getMinutes()).padStart(2, '0'); // 分钟补零
    const seconds = String(now.getSeconds()).padStart(2, '0'); // 秒补零
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0'); // 毫秒补零

    // 3. 拼接成目标字符串
    const versionStr = `V${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;

    return versionStr;
  };

  const getFormInit = () => {
    return {
      versionName: formatTimeToVersion(),
    };
  };

  if (showPublish) {
    return (
      <div className="client-api-tab-publish">
        {publishStep === 2 && (
          <div className="client-api-tab-publish-tips-box">
            <img className="client-api-tab-publish-tips-icon" src={warnBlue} />
            <div className="client-api-tab-publish-tips">
              {getFormatMessage('proceed_caution_tips')}
            </div>
          </div>
        )}
        <div className="client-publish-top">
          <div className="client-publish-top-content">
            <div
              className={classNames(
                'client-publish-top-item',
                publishStep === 1 ? 'publish-active-item' : ''
              )}
            >
              <div className="client-publish-top-item-num">1</div>
              <div className="client-publish-top-item-right">
                <div className="right-title">
                  {getFormatMessage('client_preview')}
                </div>
                <div className="right-tips">
                  {getFormatMessage('client_preview_tips')}
                </div>
              </div>
            </div>
            <div className="client-publish-top-line"></div>
            <div
              className={classNames(
                'client-publish-top-item',
                publishStep === 2 ? 'publish-active-item' : ''
              )}
            >
              <div className="client-publish-top-item-num">2</div>
              <div className="client-publish-top-item-right">
                <div className="right-title">
                  {getFormatMessage('client_publish')}
                </div>
                <div className="right-tips">
                  {getFormatMessage('client_publish_tips')}
                </div>
              </div>
            </div>
          </div>
        </div>
        {publishStep === 1 && (
          <div className="client-publish-table">
            <AutoTable list={noPublishList} configFields={publishColumns} />
          </div>
        )}
        {publishStep === 2 && (
          <Form form={versionForm} initialValues={getFormInit()}>
            <div className="publish-version-info">
              {getFormatMessage('version_info')}
            </div>
            <div className="publish-version-name-box">
              <span className="publish-version-name">
                {getFormatMessage('env_table_name')}
              </span>
              <CustomPopover content={getFormatMessage('version_name_tips')}>
                <img src={questionIcon} className="publish-version-icon" />
              </CustomPopover>
            </div>
            <Form.Item
              name="versionName"
              rules={[
                {
                  required: true,
                  message: getFormatMessage('version_name_required_validator'),
                },
                { validator: handleNameBlur },
              ]}
            >
              <Input
                className="publish-version-name-input"
                style={{ width: 520 }}
              />
            </Form.Item>
            <div className="publish-version-name-box">
              <span className="publish-version-name">
                {getFormatMessage('description')}
              </span>
              <CustomPopover content={getFormatMessage('version_desc_tips')}>
                <img src={questionIcon} className="publish-version-icon" />
              </CustomPopover>
            </div>
            <Form.Item
              name="versionDesc"
              rules={[{ validator: handleDescBlur }]}
            >
              <Input.TextArea className="publish-version-name-input" />
            </Form.Item>
          </Form>
        )}
        <div className="client-publish-btn">
          <div className="client-publish-btn-cancel" onClick={cancelPublish}>
            {getFormatMessage('cancel')}
          </div>
          <div className="client-publish-btn-ok" onClick={submitPublish}>
            {publishStep === 1
              ? getFormatMessage('apply_next_btn')
              : getFormatMessage('submit')}
          </div>
        </div>
      </div>
    );
  }

  const noPublishItem =
    clientApi?.drafts &&
    clientApi.drafts.find((item) => item.is_published === 0);

  return (
    <Spin spinning={loading} size="large">
      <div className="client-api-tab">
        {noPublishItem && isAbled && (
          <div className="client-api-publish-box">
            <div className="client-api-publish-left">
              <img
                src={warningCircleFill}
                className="client-api-publish-left-icon"
              />
              <span className="client-api-publish-left-tips">
                {getFormatMessage(
                  isNeedPoll
                    ? 'currently_task_being_published'
                    : 'unpublished_changes'
                )}
              </span>
            </div>
            {!isNeedPoll && (
              <div className="client-api-publish-right">
                <PermissionCheck
                  permissionKey={RbacRoleObjectKey.ClientAPIControlEdit}
                >
                  <div
                    className="client-api-publish-right-discard"
                    onClick={() => setShowDiscardConfirm(true)}
                  >
                    {getFormatMessage('discard_all')}
                  </div>
                </PermissionCheck>
                <PermissionCheck
                  permissionKey={RbacRoleObjectKey.ClientAPIControlEdit}
                >
                  <div
                    className="client-api-publish-right-publish"
                    onClick={() => setShowPublish(true)}
                  >
                    {getFormatMessage('api_publish')}
                  </div>
                </PermissionCheck>
              </div>
            )}
          </div>
        )}
        <div className="client-api-header">
          <div className="client-api-header-env">
            <Input.Group
              compact
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Input
                style={{
                  width: '48px',
                  height: '32px',
                  borderRight: 'none',
                  pointerEvents: 'none',
                  borderRadius: '4px 0 0 4px',
                  fontSize: '14px',
                  color: '#86909C',
                  lineHeight: '32px',
                  textAlign: 'center',
                  padding: 0,
                }}
                defaultValue={getFormatMessage('env')}
                readOnly
              />
              <Select
                onChange={handleEnvChange}
                value={selectEnv}
                style={{ width: 192 }}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        color: '#5764f1',
                        paddingLeft: '12px',
                        height: '32px',
                        lineHeight: '32px',
                        borderTop: '1px solid #F2F3F5',
                      }}
                    >
                      <PermissionCheck
                        permissionKey={RbacRoleObjectKey.EnvCreate}
                      >
                        <span
                          onClick={props.onShowCreateDrawer}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={addIcon}
                            style={{
                              display: 'inline-block',
                              width: '12px',
                              height: '12px',
                              marginRight: '4px',
                            }}
                          />
                          <span style={{ fontSize: '14px' }}>
                            {getFormatMessage('add_environment')}
                          </span>
                        </span>
                      </PermissionCheck>
                    </div>
                  </>
                )}
              >
                {props.envList.map((item) => {
                  return (
                    <Select.Option value={item.id}>
                      <div className="client-env-select-item-content">
                        <span className="client-env-filter-show-env-text">
                          {item.Name} - {getRegionName(item.Region) || ''}
                        </span>
                        {item.Type === 'DEV' && (
                          <img
                            src={EnvDevIcon}
                            className="client-env-filter-show-env-type"
                          />
                        )}
                        {item.Type === 'LIVE' && (
                          <img
                            src={EnvLiveIcon}
                            className="client-env-filter-show-env-type"
                          />
                        )}
                      </div>
                    </Select.Option>
                  );
                })}
              </Select>
            </Input.Group>
            {historyTask?.[0]?.creator && isAbled && (
              <div className="client-api-header-history">
                <span>{getFormatMessage('finally_released')}</span>
                <span style={{ marginRight: 4 }}>
                  {getCreateName(historyTask ? historyTask[0]?.creator : '')}
                </span>
                <span>
                  {historyTask
                    ? getUserConfigZoneTimeByUTC8(
                        historyTask?.[0]?.create_time,
                        userInfo?.UserSettings?.Timezone
                      )
                    : ''}
                </span>
                <div className="history-icon-box" onClick={goToHistory}>
                  <img src={HistoryIcon} className="history-icon" />
                </div>
              </div>
            )}
          </div>
        </div>
        {isAbled && (
          <div className="client-api-body">
            {renderLeftMenu()}
            <div className="client-api-body-right">
              <AutoTable
                list={filterList}
                configFields={columns}
                tableExtension={{
                  rowClassName(record: IClientAPIList) {
                    const drafts = clientApi?.drafts || [];
                    const draftItem = drafts.find(
                      (item) =>
                        item.client_api_key === record.api_name &&
                        item.package_name_service_name ===
                          record.package_name_service_name
                    );
                    if (draftItem?.is_published === 0) {
                      return 'modify-item-td';
                    }
                    return '';
                  },
                }}
                key={`${selectService}-${Math.random()}`}
              />
            </div>
          </div>
        )}
        {!isAbled && (
          <div className="client-api-empty">
            <img src={emptyPng} />
            <div>{getFormatMessage('upgrade_version_tips')}</div>
          </div>
        )}
        {renderDiscardConfirm()}
        {/* {renderPublishConfirm()} */}
      </div>
    </Spin>
  );
};
